import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomToastService, CustomToast } from '@foxera/shared/services/custom-toast.service';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss']
})
export class CustomToastComponent {
  toastService = inject(CustomToastService);

  onUndo(toast: CustomToast): void {
    this.toastService.executeUndo(toast.id);
  }

  onClose(toast: CustomToast): void {
    this.toastService.closeToast(toast.id);
  }

  onClick(toast: CustomToast): void {
    if (toast.clickCallback) {
      toast.clickCallback();
    }
    this.toastService.closeToast(toast.id);
  }

  onMouseEnter(toast: CustomToast): void {
    this.toastService.pauseToast(toast.id);
  }

  onMouseLeave(toast: CustomToast): void {
    this.toastService.resumeToast(toast.id);
  }
}

